// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2Q0kE","head":"ProcedureTableInfo_head__b1RR-"};